// extracted by mini-css-extract-plugin
module.exports = {"container":"Quiz_container__1C9Ge","QuizCount":"Quiz_QuizCount__2Qw-j","text":"Quiz_text__3-jxY","QuizText":"Quiz_QuizText__1hmUf"};